module.exports = __webpack_public_path__ + "static/assets/6167390654486afc0f0bff55fa9231c8.png";